import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faCirclePlay, faCheck } from "@fortawesome/free-solid-svg-icons";
import Text from "../components/atoms/Text";
import Button from "../components/atoms/Button";
import products from "../data/products.json";
import { useUser } from "../context/UserContext";
import socialMedias from "../assets/Social Medias.png";

const tabContent = {
  description: {
    title: "Descriptions",
    body: [
      "Sed commodo aliquam dui ac porta. Fusce ipsum felis, imperdiet at posuere ac, viverra at mauris. Maecenas tincidunt ligula a sem vestibulum pharetra. Maecenas auctor tortor lacus, nec laoreet nisi porttitor vel.",
      "Nulla mauris tellus, feugiat quis pharetra sed, gravida ac dui. Sed iaculis, metus faucibus elementum tincidunt, turpis mi viverra velit, pellentesque tristique neque mi eget nulla.",
    ],
    bullets: [
      "100 g of fresh leaves provides.",
      "Aliquam ac est at augue volutpat elementum.",
      "Quisque nec enim eget sapien molestie.",
      "Proin convallis odio volutpat finibus posuere.",
    ],
  },
  additional: {
    title: "Additional Information",
  },
  feedback: {
    title: "Customer Feedback",
    reviews: [
      {
        name: "Kristin Watson",
        avatar: require("../assets/user1.png"),
        date: "2 min ago",
        text: "Duis at ullamcorper nulla, eu dictum eros.",
      },
      {
        name: "Jane Cooper",
        avatar: require("../assets/user2.png"),
        date: "30 Apr, 2021",
        text: "Keep the soil evenly moist for the healthiest growth. If the sun gets too hot, Chinese cabbage tends to bolt or go to seed. In dry periods of heat, some kind of shade may be helpful. Watch out for snails, as they will harm the plants.",
      },
      {
        name: "Jacob Jones",
        avatar: require("../assets/user3.png"),
        date: "2 min ago",
        text: "Vivamus eget euismod magna. Nam sed lacinia nibh, et lacinia lacus.",
      },
      {
        name: "Ralph Edwards",
        avatar: require("../assets/user1.png"),
        date: "2 min ago",
        text: "200+ Canton Pak Choi Bok Choy Chinese Cabbage Seeds Heirloom Non-GMO Productive Brassica rapa VAR. chinensis, aka Cabbage Pak Choi, Bok Choi, from USA.",
      },
    ],
  },
};

function formatCurrency(value) {
  return `$${Number(value).toFixed(2)}`;
}

function renderStarRow(count = 5) {
  return (
    <div style={{ display: "inline-flex", gap: "2px", color: "var(--warning)", fontSize: "12px" }}>
      {Array.from({ length: count }).map((_, index) => (
        <FontAwesomeIcon key={index} icon={faStar} />
      ))}
    </div>
  );
}

export default function SinglePage() {
  const { id } = useParams();
  const { currentUser, replaceCart, toggleWishlist, isInWishlist } = useUser();
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState("description");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [id]);

  const product = useMemo(
    () => products.find((item) => String(item.id) === String(id)),
    [id],
  );

  if (!product) {
    return (
      <div style={{ padding: "60px 300px 100px", backgroundColor: "var(--white)" }}>
        <Text size="px32" weight="w600" color="gray9">
          Product not found.
        </Text>
      </div>
    );
  }

  const isWishlisted = isInWishlist(product.id);

  async function handleAddToCart() {
    const existingCart = currentUser?.cart || [];
    const existingItem = existingCart.find((item) => item.productId === product.id);
    const updatedCart = existingItem
      ? existingCart.map((item) =>
          item.productId === product.id
            ? { ...item, quantity: item.quantity + quantity }
            : item,
        )
      : [...existingCart, { productId: product.id, quantity }];

    await replaceCart(updatedCart);
  }

  function renderDescriptionTab() {
    return (
      <div className="single-page-description" style={{ display: "grid", gridTemplateColumns: "1.05fr 0.95fr", gap: "36px", alignItems: "start" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "18px", alignItems: "start" }}>
          {tabContent.description.body.map((paragraph) => (
            <Text
              key={paragraph}
              size="px14"
              weight="w400"
              color="gray5"
              extraStyles={{ lineHeight: "170%", textAlign: "start" }}
            >
              {paragraph}
            </Text>
          ))}

          <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "start" }}>
            {tabContent.description.bullets.map((bullet) => (
              <div key={bullet} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    backgroundColor: "var(--primary)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--white)",
                    fontSize: "11px",
                  }}
                >
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <Text size="px14" weight="w400" color="gray5">
                  {bullet}
                </Text>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div
            style={{
              height: "360px",
              borderRadius: "8px",
              backgroundImage: `url(${require("../assets/video.png")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <button
              type="button"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "var(--primary)",
                color: "var(--white)",
                fontSize: "34px",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faCirclePlay} />
            </button>
          </div>

          <div
            style={{
              border: "1px solid var(--gray1)",
              borderRadius: "8px",
              padding: "20px 24px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span style={{ color: "var(--primary)", fontSize: "26px" }}>%</span>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                <Text size="px14" weight="w500" color="gray9">
                  64% Discount
                </Text>
                <Text size="px12" weight="w400" color="gray5">
                  Save your money with us
                </Text>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span style={{ color: "var(--primary)", fontSize: "26px" }}>*</span>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                <Text size="px14" weight="w500" color="gray9">
                  100% Organic
                </Text>
                <Text size="px12" weight="w400" color="gray5">
                  100% Organic Vegetables
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderAdditionalInfoTab() {
    const infoRows = [
      ["Weight:", "03"],
      ["Color:", "Green"],
      ["Type:", "Organic"],
      ["Category:", "Vegetables"],
      ["Stock Status:", "Available (5,413)"],
      ["Tags:", "Vegetables, Healthy, Chinese, Cabbage, Green Cabbage,"],
    ];

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "28px" }}>
        <div
          className="single-page-additional-specs"
          style={{
            display: "grid",
            gridTemplateColumns: "160px 1fr",
            rowGap: "18px",
            columnGap: "24px",
            alignItems: "start",
            justifyContent: "start",
            maxWidth: "760px",
            margin: "0 auto",
            width: "100%",
          }}
        >
          {infoRows.map(([label, value]) => (
            <React.Fragment key={label}>
              <Text
                size="px16"
                weight="w400"
                color="gray9"
                extraStyles={{ textAlign: "start" }}
              >
                {label}
              </Text>
              <Text
                size="px16"
                weight="w400"
                color="gray5"
                extraStyles={{ textAlign: "start", lineHeight: "160%" }}
              >
                {value}
              </Text>
            </React.Fragment>
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px", maxWidth: "1320px", margin: "0 auto", width: "100%" }}>
          <div
            className="single-page-additional-media"
            style={{
              height: "520px",
              borderRadius: "8px",
              backgroundImage: `linear-gradient(rgba(44, 116, 47, 0.35), rgba(44, 116, 47, 0.35)), url(${require("../assets/video.png")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <button
              type="button"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "108px",
                height: "108px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "var(--primary)",
                color: "var(--white)",
                fontSize: "42px",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faCirclePlay} />
            </button>
          </div>

          <div
            className="single-page-additional-benefits"
            style={{
              border: "1px solid var(--gray1)",
              borderRadius: "8px",
              padding: "24px 28px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "24px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <span style={{ color: "var(--primary)", fontSize: "38px", lineHeight: 1 }}>%</span>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                <Text size="px24" weight="w500" color="gray9">
                  64% Discount
                </Text>
                <Text size="px16" weight="w400" color="gray5">
                  Save your money with us
                </Text>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <span style={{ color: "var(--primary)", fontSize: "38px", lineHeight: 1 }}>*</span>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                <Text size="px24" weight="w500" color="gray9">
                  100% Organic
                </Text>
                <Text size="px16" weight="w400" color="gray5">
                  100% Organic Vegetables
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderFeedbackTab() {
    return (
      <div
        className="single-page-feedback"
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          borderTop: "1px solid var(--gray1)",
        }}
      >
        {tabContent.feedback.reviews.map((review) => (
          <div
            key={`${review.name}-${review.date}`}
            style={{
              display: "flex",
              gap: "16px",
              padding: "20px 0",
              borderBottom: "1px solid var(--gray1)",
            }}
          >
            <img
              src={review.avatar}
              alt={review.name}
              style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover" }}
            />
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "start" }}>
                  <Text size="px14" weight="w500" color="gray9" extraStyles={{ textAlign: "start" }}>
                    {review.name}
                  </Text>
                  {renderStarRow()}
                </div>
                <Text size="px12" weight="w400" color="gray4">
                  {review.date}
                </Text>
              </div>
              <Text
                size="px14"
                weight="w400"
                color="gray5"
                extraStyles={{ textAlign: "start", lineHeight: "170%" }}
              >
                {review.text}
              </Text>
            </div>
          </div>
        ))}
      </div>
    );
  }

  function renderTabContent() {
    if (activeTab === "additional") {
      return renderAdditionalInfoTab();
    }

    if (activeTab === "feedback") {
      return renderFeedbackTab();
    }

    return renderDescriptionTab();
  }

  return (
    <div className="single-page" style={{ padding: "40px 300px 100px", backgroundColor: "var(--white)" }}>
      <div
        className="single-page-hero"
        style={{
          display: "grid",
          gridTemplateColumns: "1.05fr 1fr",
          gap: "40px",
          alignItems: "start",
        }}
      >
        <div
          style={{
            minHeight: "560px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            backgroundColor: "var(--white)",
          }}
        >
          <img
            src={product.image}
            alt={product.name}
            style={{ width: "100%", maxWidth: "620px", height: "auto", objectFit: "contain" }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "start" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <Text size="px40" weight="w600" color="gray9">
              {product.name}
            </Text>
            <span
              style={{
                padding: "4px 10px",
                borderRadius: "4px",
                backgroundColor: "#EAF7E9",
                color: "var(--primary)",
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              In Stock
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
            <div style={{ display: "inline-flex", gap: "4px", color: "var(--warning)" }}>
              {Array.from({ length: 5 }).map((_, index) => (
                <FontAwesomeIcon key={index} icon={faStar} />
              ))}
            </div>
            <Text size="px14" weight="w400" color="gray5">
              4 Review
            </Text>
            <Text size="px14" weight="w400" color="gray4">
              SKU: 2J15194
            </Text>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            {product.hasDiscount ? (
              <>
                <Text
                  size="px20"
                  weight="w400"
                  color="gray4"
                  extraStyles={{ textDecoration: "line-through" }}
                >
                  {formatCurrency(product.originalPrice)}
                </Text>
                <Text size="px32" weight="w600" color="primary">
                  <span style={{ color: "var(--hard-primary)" }}>
                    {formatCurrency(product.price)}
                  </span>
                </Text>
                <span
                  style={{
                    padding: "3px 10px",
                    borderRadius: "30px",
                    backgroundColor: "#FDEDED",
                    color: "#EA4B48",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% Off
                </span>
              </>
            ) : (
              <Text size="px32" weight="w600" color="primary">
                <span style={{ color: "var(--hard-primary)" }}>
                  {formatCurrency(product.price)}
                </span>
              </Text>
            )}
          </div>

          <div
            style={{
              width: "100%",
              padding: "24px 0",
              borderTop: "1px solid var(--gray1)",
              borderBottom: "1px solid var(--gray1)",
              display: "flex",
              flexDirection: "column",
              gap: "18px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", width: "100%" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Text size="px14" weight="w400" color="gray5">
                  Brand:
                </Text>
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    border: "1px solid var(--gray1)",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--primary)",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  shopery
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Text size="px14" weight="w400" color="gray5">
                  Share item:
                </Text>
                <img
                  src={socialMedias}
                  alt="Social media"
                  style={{ width: "184px", height: "40px", objectFit: "contain" }}
                />
              </div>
            </div>

            <Text
              size="px14"
              weight="w400"
              color="gray5"
              extraStyles={{ lineHeight: "170%", textAlign: "start" }}
            >
              Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla nibh diam, blandit vel consequat nec, ultrices et ipsum. Nulla varius magna a consequat pulvinar.
            </Text>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              paddingBottom: "20px",
              borderBottom: "1px solid var(--gray1)",
            }}
          >
            <div
              style={{
                width: "140px",
                height: "50px",
                border: "1px solid var(--gray1)",
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 8px",
              }}
            >
              <button
                type="button"
                onClick={() => setQuantity((current) => Math.max(1, current - 1))}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "var(--gray05)",
                  color: "var(--gray5)",
                  fontSize: "22px",
                  cursor: "pointer",
                }}
              >
                -
              </button>
              <Text size="px18" weight="w500" color="gray9">
                {quantity}
              </Text>
              <button
                type="button"
                onClick={() => setQuantity((current) => current + 1)}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "var(--gray05)",
                  color: "var(--gray5)",
                  fontSize: "22px",
                  cursor: "pointer",
                }}
              >
                +
              </button>
            </div>

            <Button size="large" variant="fill" onClick={handleAddToCart} style={{ flex: 1, justifyContent: "center" }}>
              Add to Cart
            </Button>

            <button
              type="button"
              onClick={() => toggleWishlist(product)}
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "50%",
                border: "1px solid var(--gray1)",
                backgroundColor: isWishlisted ? "#EAF7E9" : "var(--white)",
                color: isWishlisted ? "var(--primary)" : "var(--gray7)",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              {isWishlisted ? "?" : "?"}
            </button>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "start" }}>
            <Text size="px14" weight="w400" color="gray7">
              <span style={{ fontWeight: 600, color: "var(--gray9)" }}>Category:</span> Vegetables
            </Text>
            <Text size="px14" weight="w400" color="gray7">
              <span style={{ fontWeight: 600, color: "var(--gray9)" }}>Tag:</span> Vegetables Healthy Chinese Cabbage Green Cabbage
            </Text>
          </div>
        </div>
      </div>

      <div className="single-page-tabs-section" style={{ marginTop: "56px" }}>
        <div
          className="single-page-tab-nav"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            borderBottom: "1px solid var(--gray1)",
            marginBottom: "32px",
          }}
        >
          {Object.entries(tabContent).map(([key, item]) => (
            <button
              key={key}
              type="button"
              onClick={() => setActiveTab(key)}
              style={{
                border: "none",
                backgroundColor: "transparent",
                borderBottom: activeTab === key ? "2px solid var(--primary)" : "2px solid transparent",
                padding: "0 0 16px",
                color: activeTab === key ? "var(--gray9)" : "var(--gray5)",
                fontSize: "16px",
                fontWeight: activeTab === key ? 500 : 400,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              {item.title}
            </button>
          ))}
        </div>

        {renderTabContent()}
      </div>
    </div>
  );
}
